import { useSyncExternalStore } from 'react';

import { type AutomationNudgeActionEntry } from '../hooks/useConfluenceAutomationNudgeActions.tsx';

const NO_ACTIONS: AutomationNudgeActionEntry[] = [];

let snapshot: AutomationNudgeActionEntry[] = NO_ACTIONS;
const listeners = new Set<() => void>();

const emit = () => {
	listeners.forEach((listener) => listener());
};

const subscribe = (onStoreChange: () => void) => {
	listeners.add(onStoreChange);
	return () => {
		listeners.delete(onStoreChange);
	};
};

const getSnapshot = (): AutomationNudgeActionEntry[] => snapshot;

const areEntriesEqual = (
	a: AutomationNudgeActionEntry[],
	b: AutomationNudgeActionEntry[],
): boolean =>
	a.length === b.length &&
	a.every((entry, i) => entry.actionId === b[i].actionId && entry.action === b[i].action);

export const publishAutomationNudgeActions = (actions: AutomationNudgeActionEntry[]): void => {
	const next = actions.length === 0 ? NO_ACTIONS : actions;
	if (areEntriesEqual(snapshot, next)) {
		return;
	}
	snapshot = next;
	emit();
};

export const clearAutomationNudgeActions = (): void => {
	publishAutomationNudgeActions(NO_ACTIONS);
};

export const clearAutomationNudgeActionsForTesting = (): void => {
	snapshot = NO_ACTIONS;
	listeners.clear();
};

/** Returns the automation discovery nudge actions published by `<AutomationNudgeActionsLoader />`. */
export const useAutomationNudgeActions = (): AutomationNudgeActionEntry[] =>
	useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
